// Quill writes alignment and indentation as classes (ql-align-center,
// ql-indent-1) that only its own stylesheet understands, and the app's
// Tailwind reset strips bullets and link styling from bare <ul>/<a>. An email
// has neither stylesheet, so the body must carry every style inline. Used for
// BOTH the preview and the send, so the preview is what recipients get.

const LINK_COLOR = "#1a73e8";
const INDENT_EM = 3; // matches Quill's own 3em per indent level

const addStyle = (el, prop, value) => {
  // Never override a style the editor already set explicitly.
  if (!el.style[prop]) el.style[prop] = value;
};

export const toEmailHtml = (html) => {
  if (!html) return "";
  const root = document.createElement("div");
  root.innerHTML = html;

  root.querySelectorAll("ul").forEach((ul) => {
    addStyle(ul, "listStyleType", "disc");
    addStyle(ul, "paddingLeft", "24px");
    addStyle(ul, "margin", "0 0 16px 0");
  });
  root.querySelectorAll("ol").forEach((ol) => {
    addStyle(ol, "listStyleType", "decimal");
    addStyle(ol, "paddingLeft", "24px");
    addStyle(ol, "margin", "0 0 16px 0");
  });
  root.querySelectorAll("a").forEach((a) => {
    addStyle(a, "color", LINK_COLOR);
    addStyle(a, "textDecoration", "underline");
  });

  root.querySelectorAll('[class*="ql-"]').forEach((el) => {
    const kept = [];
    el.classList.forEach((cls) => {
      const align = cls.match(/^ql-align-(center|right|justify)$/);
      const indent = cls.match(/^ql-indent-(\d+)$/);
      if (align) addStyle(el, "textAlign", align[1]);
      else if (indent) {
        addStyle(el, "marginLeft", `${Number(indent[1]) * INDENT_EM}em`);
      } else if (!cls.startsWith("ql-")) kept.push(cls);
    });
    if (kept.length) el.className = kept.join(" ");
    else el.removeAttribute("class");
  });

  return root.innerHTML;
};
